(function ($, Drupal, window, document) {
  'use strict'

  // expand animation function
  function autoHeightAnimate (element, time) {
    const curHeight = element.height() // Get Default Height
    const autoHeight = element.css('height', 'auto').height() // Get Auto Height
    element.height(curHeight) // Reset to Default Height
    element.stop().animate({ height: autoHeight }, time) // Animate to Auto Height
  }

  // ! Main menu and mobile icon
  Drupal.behaviors.mainNavigation = {
    attach: function (context, settings) {
      $('.site-header', context).once('mainmenu').each(function () {
        const $menuContainer = $('.site-header')
        const mobileMenuButton = '.site-header .navigation.menu--main .menu-button'
        const mainMenu = $('.site-header .region-header.accessible')
        const animateTime = 200
        // toggle
        $(mobileMenuButton, context).on('click', function () {
          if ($menuContainer.hasClass('mobile-menu-open')) {
            $(mobileMenuButton).attr('aria-expanded', 'false')
            $menuContainer.removeClass('mobile-menu-open')
            mainMenu.stop().animate({ height: '0' }, animateTime)
          } else {
            $menuContainer.addClass('mobile-menu-open')
            $(mobileMenuButton).attr('aria-expanded', 'true')
            autoHeightAnimate(mainMenu, animateTime)
          }
        })

        $(window).resize(function () {
          if ($(window).width() > 992) {
            // Clear out mobile-menu.
            $menuContainer.removeClass('mobile-menu-open')
            mainMenu.css('height', '')
          } else if ($menuContainer.hasClass('mobile-menu-open')) {
            mainMenu.css('height', 'auto')
          }
        })

        // click open org drop-down menu
        // ----------------------------------------------
        const organization = '.views-field.views-field-field-organization'
        const organizationLabel = '.views-field.views-field-field-organization .views-label'
        // append drop-down arrow to menu item
        $('<span><i></i><i></i></span>').appendTo(organizationLabel)
        // add accessibly attribute
        $(organization).attr({
          'aria-expanded': 'false',
          'aria-haspopup': 'true'
        })
        // toggle
        $(organizationLabel).click(function () {
          if ($(window).width() > 992) {
            const $this = $(this)
            if ($this.parent(organization).hasClass('menu-open')) {
              $this.parent(organization).removeClass('menu-open').attr('aria-expanded', 'false')
            } else {
              $(organization).removeClass('menu-open').attr('aria-expanded', 'false')
              $this.parent(organization).addClass('menu-open').attr('aria-expanded', 'true')
            }
          }
        })

        // Hide drop-down menu on outside click
        $(document).on('click', function (e) {
          if ($(organization).hasClass('menu-open') && $(e.target).closest(organizationLabel).length === 0) {
            $(organization).removeClass('menu-open').attr('aria-expanded', 'false')
          }
        })

        // Hide drop-down menu by pressing the ESC key
        $(document).keyup(function (e) {
          if ($(organization).hasClass('menu-open') && e.keyCode === 27) {
            $(organization).removeClass('menu-open').attr('aria-expanded', 'false')
          }
        })
      })
    }
  }

  // ! basictable.js
  Drupal.behaviors.basicTables = {
    attach: function (context, settings) {
      const contentTable = '#block-dukecancernetwork-content table'
      $(contentTable, context).once('basictables').each(function () {
        $(contentTable).basictable({
          breakpoint: 768
        })
      })
    }
  }
})(window.jQuery, window.Drupal, this, this.document, window.viewportCore)
